/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyAirdropInfo.vue?vue&type=template&id=35e980a2&scoped=true"
import script from "./popLuckyAirdropInfo.vue?vue&type=script&lang=js"
export * from "./popLuckyAirdropInfo.vue?vue&type=script&lang=js"
import style0 from "./popLuckyAirdropInfo.vue?vue&type=style&index=0&id=35e980a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e980a2",
  null
  
)

export default component.exports